import { useState } from "react";
import Tooltip from "../tooltip/tooltip.component";
import Box from "../box/box.component";

const getAvatarUrl = (id, userList) => {
  if (!id || !Array.isArray(userList)) return null;
  const p = userList.find((x) => Number(x.id) === Number(id));
  if (!p) return null;
  return p.avatar || null;
};

const getInitials = (id, userList) => {
  if (!id || !Array.isArray(userList)) return "";
  const p = userList.find((x) => Number(x.id) === Number(id));
  if (!p) return "";
  const nome = p.nomeRazaoSocial || p.nome || "";
  const parts = nome.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "";
  return {
    initials: parts
      .slice(0, 2)
      .map((w) => (w[0] || "").toUpperCase())
      .join(""),
    fullName: nome.toUpperCase(),
  };
};

export default function Avatar({ 
  id, 
  userList,
}) {

  const [imgError, setImgError] = useState(false);
  const avatarUrl = getAvatarUrl(id, userList);
  const { initials, fullName } = getInitials(id, userList);
  const SIZE = 28;

  if (avatarUrl && !imgError) {
    return (
      <Tooltip title={fullName} arrow placement="right">
        <Box
          className="d-flex align-items-center justify-content-center rounded-circle"
          sx={{
            width: SIZE,
            height: SIZE,
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={avatarUrl}
            alt={initials || "avatar"}
            style={{
              width: SIZE,
              height: SIZE,
              objectFit: "cover",
              display: "block",
            }}
            onError={() => setImgError(true)}
          />
        </Box>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={fullName} arrow placement="right">
      <Box
        className="d-flex align-items-center justify-content-center rounded-circle"
        sx={{
          width: SIZE,
          height: SIZE,
          backgroundColor: "#d9e6ffff",
          fontSize: 11,
          color: "#244969",
          fontWeight: 700,
        }}
      >
        {initials}
      </Box>
    </Tooltip>
  );
}